<ng-container *ngIf="isLoading$ | async"></ng-container>
<ngx-spinner></ngx-spinner>
<div class="page-title-area page-title-four">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2> {{'MENU.CAREERS' | translate}} </h2>
                <ul>
                    <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>{{'MENU.CAREERS' | translate}}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<section class="appointment-area-two" style="margin-top: 20px;margin-bottom: -115px;">
    <div class="container">
        <div class="row align-items-center appointment-wrap-two">
            <div class="col-lg-12 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                <div class="appointment-item appointment-item-two ">
                    <div class="text-center" style="margin: -20px 0px 10px 0px;">
                        <p style="font-weight: bold;font-size: 18px; color: white !important;">
                            {{ language == 'en'? 'To join the Balsam Medical Care team, please fill out the form below:'
                            :'للانضمام إلى فريق بلسم للرعاية الطبية، يرجى ملء النموذج أدناه:' }}</p>
                    <hr>
                        </div>
                    
                    <div class="appointment-form">
                        <form [formGroup]="formGroup">
                            <div class="row g-3">
                          
                              <div class="col-md-6">
                                <div class="form-group">
                                    <label for="jobTitle" style="font-weight: 500;color: rgb(182 142 39);font-size: 20px;">{{ language == 'en' ? 'Speciality' : 'التخصص' }} </label><label class="text-danger">*</label>
                                    <input   [class.is-invalid]="isControlInvalid('Sepciality')"
                                    [class.is-valid]="isControlValid('Sepciality')" type="text" class="form-control" id="Sepciality" formControlName="Sepciality" placeholder="{{ language == 'en' ? 'Write speciality here' : 'اكتب التخصص هنا' }}">
                                    <div class="invalid-feedback ValidateText" *ngIf="controlHasError('required', 'Sepciality')">
                                      {{'AUTH.VALIDATION.REQUIRED' | translate : {'name':language == 'en'? 'Sepciality':'التخصص' } }}
                                  </div>
                                  <div class="invalid-feedback ValidateText" *ngIf="controlHasError('pattern', 'Sepciality')">
                                      {{'AUTH.VALIDATION.NAME_VALIDATION' | translate}}
                                  </div>
                                  </div>
                               
                              </div>
                          
                              <div class="col-md-6">
                                <div class="form-group">
                                    <label for="nationality" style="font-weight: 500;color: rgb(182 142 39);font-size: 20px;">{{ language == 'en' ? 'Nationality' : 'الجنسية' }} </label><label class="text-danger">*</label>
                                <input  [class.is-invalid]="isControlInvalid('nationality')"
                                [class.is-valid]="isControlValid('nationality')" type="text" type="text" class="form-control" id="nationality" formControlName="nationality" placeholder="{{ language == 'en' ? 'Please write nationality' : 'اكتب الجنسية من فضلك' }}">
                                <div class="invalid-feedback ValidateText" *ngIf="controlHasError('required', 'nationality')">
                                  {{'AUTH.VALIDATION.REQUIRED' | translate : {'name':language == 'en'? 'Nationality':'الجنسية' } }}
                              </div>
                              <div class="invalid-feedback ValidateText" *ngIf="controlHasError('pattern', 'nationality')">
                                  {{'AUTH.VALIDATION.NAME_VALIDATION' | translate}}
                              </div>
                              </div>
                                
                              </div>
                          
                              <div class="col-md-6">
                                <div class="form-group">
                                    <label for="gender" style="font-weight: 500;color: rgb(182 142 39);font-size: 20px;">{{ language == 'en' ? 'Gender' : 'الجنس' }}</label><label class="text-danger">*</label>
                                    <select [class.is-invalid]="isControlInvalid('gender')"
                                    [class.is-valid]="isControlValid('gender')" class="form-control" id="gender" formControlName="gender">
                                    <option value="">{{ language == 'en' ? 'Please Select' : 'يرجى الاختيار' }}</option>
                                    <option value="male">{{ language == 'en' ? 'Male' : 'ذكر' }}</option>
                                    <option value="female">{{ language == 'en' ? 'Female' : 'أنثى' }}</option>
                                    </select>
                                    <div class="invalid-feedback ValidateText" *ngIf="controlHasError('required', 'gender')">
                                      {{'AUTH.VALIDATION.REQUIRED' | translate : {'name':language == 'en'? 'Gender':'الجنس' } }}
                                  </div>
                                </div>
                                
                              </div>
                          
                              <div class="col-md-6">
                                <div class="form-group">
                                    <label for="fullName" style="font-weight: 500;color: rgb(182 142 39);font-size: 20px;">{{ language == 'en' ? 'Full Name' : 'الاسم الكامل' }} </label><label class="text-danger">*</label>
                                <input [class.is-invalid]="isControlInvalid('fullName')"
                                [class.is-valid]="isControlValid('fullName')"  type="text" class="form-control" id="fullName" formControlName="fullName" placeholder="{{ language == 'en' ? 'Please write your full name' : 'اكتب اسمك الكامل' }}">
                                <div class="invalid-feedback ValidateText" *ngIf="controlHasError('required', 'fullName')">
                                  {{'AUTH.VALIDATION.REQUIRED' | translate : {'name':language == 'en'? 'Full Name':'الاسم الكامل' } }}
                              </div>
                              <div class="invalid-feedback ValidateText" *ngIf="controlHasError('pattern', 'fullName')">
                                  {{'AUTH.VALIDATION.NAME_VALIDATION' | translate}}
                              </div>  
                              </div>
                                
                              </div>
                          
                              <div class="col-md-6">
                                <div class="form-group">
                                    <label for="email" style="font-weight: 500;color: rgb(182 142 39);font-size: 20px;">{{ language == 'en' ? 'E-Mail' : 'البريد الإلكتروني' }} </label><label class="text-danger">*</label>
                                    <input [class.is-invalid]="isControlInvalid('email')"
                                    [class.is-valid]="isControlValid('email')" type="email" class="form-control" id="email" formControlName="email" placeholder="{{ language == 'en' ? 'Please write your email' : 'اكتب بريدك الإلكتروني' }}">
                                    <div class="invalid-feedback ValidateText" *ngIf="controlHasError('required', 'email')">
                                      {{'AUTH.VALIDATION.REQUIRED' | translate : {'name':language == 'en'? 'E-Mail':'البريد الإلكتروني' } }}
                                  </div>
                                  </div>
                               
                              </div>
                          
                              <div class="col-md-6">
                                <div class="form-group">
                                    <label for="mobile" style="font-weight: 500;color: rgb(182 142 39);font-size: 20px;">{{ language == 'en' ? 'Mobile' : 'رقم الجوال' }} </label><label class="text-danger">*</label>
                                    <label>(ex: 5xxxxxxxx)</label>
                                    <input  [class.is-invalid]="isControlInvalid('mobile')"
                                    [class.is-valid]="isControlValid('mobile')" type="text" class="form-control" id="mobile" formControlName="mobile" placeholder="{{ language == 'en' ? 'Please write your mobile' : 'اكتب رقم جوالك' }}">
                                    <div class="invalid-feedback ValidateText" *ngIf="controlHasError('required', 'mobile')">
                                      {{'AUTH.VALIDATION.REQUIRED' | translate : {'name':'BIRTHREQUEST.ADD.MOBILE' | translate } }}
                                  </div>
                                  <div class="invalid-feedback ValidateText" *ngIf="controlHasError('pattern', 'mobile')">
                                      {{ 'AUTH.VALIDATION.MOBILE_VALIDATION'| translate }}
                                  </div>
                                  </div>
                               
                              </div>
                          
                              <div class="col-md-6">

                                <label for="photo" style="font-weight: 500;color: rgb(182 142 39);font-size: 20px;">{{ language == 'en' ? 'Upload personal photo' : 'تحميل صورة شخصية' }} </label>
                                <input style="color: black !important;" (change)="AddCVAttachment($event,'Photo')"  accept=".jpg,.png,.jpeg" type="file" class="form-control" id="photo" formControlName="photo">
                                <small class="form-text text-muted">{{ language == 'en' ? '15 MB Maximum space' : '15 ميجابايت الحد الأقصى' }}</small>
                              </div>
                          
                             
                          
                              <div class="col-md-6">
                                <label for="medicalAuthority" style="font-weight: 500;color: rgb(182 142 39);font-size: 20px;">{{ language == 'en' ? 'Medical Specialties Authority' : 'هيئة التخصصات الطبية' }}</label>
                                <input style="color: black !important;" (change)="AddCVAttachment($event,'MedicalAuthority')"  accept=".pdf" type="file" class="form-control" id="medicalAuthority" formControlName="medicalAuthority">
                                <small class="form-text text-muted">{{ language == 'en' ? '15 MB Maximum space' : '15 ميجابايت الحد الأقصى' }}</small>
                              </div>

                              <div class="col-md-6">
                                <label for="cv" style="font-weight: 500;color: rgb(182 142 39);font-size: 20px;">{{ language == 'en' ? 'Upload CV' : 'تحميل السيرة الذاتية' }} </label><label class="text-danger">*</label>
                                <input (change)="AddCVAttachment($event,'CV')" style="color: black !important;" accept=".pdf,.docx" type="file" class="form-control" id="cv" formControlName="cv">
                                <small class="form-text text-muted">{{ language == 'en' ? '15 MB Maximum space (PDF, word)' : '15 ميجابايت الحد الأقصى (PDF, word)' }}</small>
                              </div>
                            </div>
                          </form>
                          
                        <div class="captcha-container">
                            <div class="captcha-header">Please verify you're human</div>
                            <div class="captcha-box">
                            <span class="captcha-code">{{ captchaCode }}</span>
                            <button class="refresh-button" (click)="refreshCaptcha()">&#x21bb;</button>
                            </div>
                            <input class="captcha-input" [(ngModel)]="userInput" placeholder="Enter CAPTCHA" style="color: black !important;">
                            <button class="validate-button" (click)="validateCaptcha()">Validate</button>
                            <div class="captcha-result" *ngIf="isValid !== undefined">
                            <span *ngIf="isValid" class="valid">CAPTCHA Validated Successfully</span>
                            <span *ngIf="!isValid" class="invalid">CAPTCHA Invalid</span>
                            </div>
                            <button class="submit-button" *ngIf="isValid" (click)="submit()">{{ 'COMMON.SUBMMIT' | translate }}</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>